export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f06003b75a335d8c80a5d117ee17c731a4848a0e8&name=fetchTypeahead!'